import { Address } from './Address';
import { UserInvitation } from './clientLocation';

export class PBUser {
	tokenTimeout?: number;
	firstName: string;
	lastName: string;
	clientId: number;
	address: Address;
	password: string;
	addressId: number;
    trackingToken: any;
    id: number;
    userName: string;
    normalizedUserName: string;
    email: string;
    normalizedEmail: string;
    emailConfirmed: boolean;
    passwordHash: string;
    securityStamp: string;
    concurrencyStamp: string;
    phoneNumber: string;
    phoneNumberConfirmed: boolean;
    twoFactorEnabled: boolean;
    lockoutEnd: Date;
    lockoutEnabled: boolean;
    accessFailedCount: number;
    ecAllowed : boolean;
    acceptedTC: boolean;
    invitation : UserInvitation;
    mobilePhone :string;
    title : string;
    fax : string;
}